import { BarisPencarianObat, HasilPencarianObat } from "@/types/pencarian_obat";

function stok(obat: Partial<HasilPencarianObat>): number {
  return Math.max(0, Number(obat.stock_qty) || 0);
}

function bandingkan(
  a: Partial<HasilPencarianObat>,
  b: Partial<HasilPencarianObat>
): number {
  const stokA = stok(a);
  const stokB = stok(b);

  if (stokA === 0 && stokB !== 0) {
    return 1;
  }
  if (stokA !== 0 && stokB === 0) {
    return -1;
  }
  if (a.nama === b.nama) {
    return stokB - stokA;
  }
  return String(a.nama || "").localeCompare(String(b.nama || ""));
}

export function susunHasilPencarianObat(
  daftar: HasilPencarianObat[]
): BarisPencarianObat[] {
  const utama = (daftar || []).slice().sort(bandingkan);
  const terpakai = new Set(utama.map(obat => obat.id));
  const hasil: BarisPencarianObat[] = [];

  utama.forEach(obat => {
    hasil.push({ ...obat, index: 0, _alternatif_dari: null });

    if (stok(obat) > 0) {
      return;
    }

    (obat.alternatif || []).forEach(pengganti => {
      if (terpakai.has(pengganti.id)) {
        return;
      }
      terpakai.add(pengganti.id);
      hasil.push({
        ...pengganti,
        alternatif: [],
        index: 0,
        _alternatif_dari: obat.nama
      });
    });
  });

  return hasil.map((obat, index) => ({ ...obat, index }));
}

export function ringkasStokObat(obat: Partial<HasilPencarianObat>): string {
  if (obat.stock_qty === null || obat.stock_qty === undefined) {
    return "stok: n/a";
  }
  return obat.stock_depo
    ? `stok depo: ${obat.stock_qty}`
    : `stok: ${obat.stock_qty}`;
}

export function petunjukAlternatifObat(
  obat: Partial<HasilPencarianObat>
): string {
  if (stok(obat) > 0 || !obat.alternatif || obat.alternatif.length === 0) {
    return "";
  }

  const daftar = obat.alternatif
    .map(pengganti => `${pengganti.nama} (${pengganti.stock_qty})`)
    .join(", ");

  return `Stok habis — tersedia GNR sama: ${daftar}`;
}
